import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const options = ref({
  chart: {
    id: "vuechart-example",
  },
  xaxis: {
    categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998],
  },
});
const series = ref([
  {
    type: "line",
    name: "chart-1",
    data: [30, 40, 45, 50, 49, 60, 70, 91],
  },
]);

return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_apexchart, {
      width: "500",
      type: "line",
      options: options.value,
      series: series.value
    }, null, 8, ["options", "series"])
  ]))
}
}

})